"use strict";

// @codekit-append 'bower_components/aos/dist/aos.js'
// @codekit-append 'bernethe_libs/bernethe.js'
var _lang;
function goWeb(eAI) {
    _lang = document.body.getAttribute('lang');
    AOS.init();
    document.getElementById('main_form').addEventListener('submit',evalForm,!1);
    //document.querySelector('.toggler-menu').addEventListener('click', toggleMenu, !1);
    document.querySelector('.cta-opener').addEventListener('click',openElement,!1);
    var ul = document.querySelector('ul#vidlist');
    for (var i = ul.children.length; i >= 0; i--) {
        ul.appendChild(ul.children[Math.random() * i | 0]);
    }
    addEventListenerList(document.querySelectorAll('a.videobox'),'click',openVideo);
}
function openVideo(eOV) {
    eOV.preventDefault();
    appendModal(`<div class="embed-container"><iframe src="${eOV.currentTarget.getAttribute('href')}" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>`);
}
function openElement(eOE) {
    eOE.preventDefault();
    document.getElementById(eOE.target.dataset.opener).classList.add('opened');
    eOE.target.classList.add('d-none');
}
function evalLang(_es,_en) {
    if(_lang == 'es') {
        return _es;
    } else {
        return _en;
    }
}

function evalForm(eEF) {
    eEF.preventDefault();
    var _m = '';

    if( document.getElementById('name_txt').value.length < 3 ) {
        _m += evalLang('<li>El campo "<strong>Nombre</strong>" es requerido</li>', '<li>The "<strong>Name</strong>" field is required</li>');
    }
    if( !email_rx.test(document.getElementById('email_txt').value) ) {
        _m += evalLang('<li>El campo "<strong>Correo Electrónico</strong>" es requerido, y debe tener el formato correcto</li>','<li>The "<strong>Email</strong>" field is required and must be in the correct format</li>');
    }
    if( document.getElementById('msj_txt').value.length < 7 ) {
        _m += evalLang('<li>El campo "<strong>Mensaje</strong>" es requerido</li>', '<li>The "<strong>Message</strong>" field is required</li>');
    }

    if(_m != '') {
        appendModal('<ul>'+_m+'</ul>', evalLang('Atención', 'Warning'));
    } else {
        appendPreloader('Procesando Datos');
        let fd = new FormData(document.querySelector('form'));
        fd.append('f', Date.now());
        
        fetch('/do-form/', {
			method: 'POST',
			headers: {
				'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
				'pragma': 'no-cache',
				'cache-control': 'no-cache'
			},
			body: new URLSearchParams(fd).toString()
		})
		.then(function (resp) {
			//console.table(resp);
			return resp;
		})
		.then(function (json) {
			console.log(json);
			removePreloader();
			document.getElementById('name_txt').value = '';
			document.getElementById('email_txt').value = '';
			document.getElementById('msj_txt').value = '';
			appendModal(evalLang('Los datos han sido enviados.','The data has been sent.'),evalLang('Listo','Done'));
		})
		.catch(function (ex) { console.log(ex); });
    }
}
/*
function toggleMenu(eTM) {
    document.querySelector('.toggler-menu').classList.toggle('opened');
    //document.querySelector('header.mkt-main-head').classList.toggle('opened');
    if (document.querySelector('.toggler-menu').classList.contains('opened')) {
        document.querySelector('.toggler-menu').innerHTML = '×';
    } else {
        document.querySelector('.toggler-menu').innerHTML = '☰';
    }
}
function addEventListenerList(list, event, fn) {
	for (var i = 0, len = list.length; i < len; i++) {
        //console.log(list[i]);
		list[i].addEventListener(event, fn, !1);
	}
};*/
document.addEventListener('DOMContentLoaded', goWeb, !1);